import { useEffect } from "react";

import { isDev } from "../../lib";

/**
 * An item's `value` must be non-empty: "" is what an empty single root holds.
 * Such an item never opens, on any platform: the native parts read the shared
 * state, since @rn-primitives would match it against an empty root. Warns in
 * development builds.
 */
export function useWarnIfEmptyItemValue(value: string) {
  useEffect(() => {
    if (value === "" && isDev()) {
      console.error(
        'AccordionItem: `value` must be non-empty; "" is the empty root value, so the item never opens.',
      );
    }
  }, [value]);
}
